﻿export const registration = (function () {
    function selectCity() {
        //constы
        const CITY_CONTAINER = document.querySelector(".registrationCity");
        const CITY_INPUT = document.querySelector("#citytext");
        const COUNTRY_INPUT = document.querySelector("#country");
        const CITY_SEARCH = document.querySelector("#citysearch");
        const CITY_SELECT = "#citysearch li a";

        if ((CITY_INPUT !== null) && (COUNTRY_INPUT !== null) &&
            (CITY_SEARCH !== null) && (CITY_CONTAINER !== null)) {
            CITY_INPUT.addEventListener("input", inputCity);
        } else {
            return;
        }

        let cityValue;
        let countryValue;

        function focusoutCity(e) {
            cityValue = e.target.value;
            countryValue = changeCountry(COUNTRY_INPUT);
            if (document.querySelectorAll(CITY_SELECT).length) {
                let cityFirst = document.querySelectorAll(CITY_SELECT)[0];
                clickCity(cityFirst);
            }
        }

        function inputCity(e) {
            cityValue = e.target.value;
            countryValue = changeCountry(COUNTRY_INPUT);
            findCity(countryValue, cityValue);
        }

        function clickCity(e) {
            if (e.target && e.target.innerHTML !== undefined) {
                cityValue = e.target.innerHTML;
            } else {
                cityValue = e.innerHTML;
            }
            CITY_INPUT.value = cityValue;
            CITY_SEARCH.innerHTML = "";
        }

        function changeCountry(e) {
            countryValue = e[e.selectedIndex].value;
            return countryValue;
        }


        function findCity(country, city) {
            let data = {
                Action: "city",
                CountryID: country,
                City: city
            }
            let postData = JSON.stringify(data);

            jQuery.ajax({
                url: '/insystem/pages/finder.cshtml',
                dataType: 'json',
                data: postData,
                success: function (Callback) {
                    CITY_SEARCH.innerHTML = "";

                    debugger;

                    for (let inini in Callback) {
                        const item = Callback[inini];
                        const li = document.createElement('li');
                        const link = document.createElement('a');
                        li.appendChild(link);
                        link.setAttribute('data-reg', 'city');
                        link.tabIndex = 20 + inini;
                        link.href = '#';
                        link.textContent = item.Name;

                        CITY_SEARCH.appendChild(li);
                    }

                    let cityList = document.querySelectorAll(CITY_SELECT);
                    cityList.forEach(function (item, i, arr) {
                        item.onclick = clickCity;
                    });
                    
                },
                error: function (Callback) {
                    console.error(Callback);
                },
                method: 'post'
            })
        }
    }

    return {
        selectCity
    }
})();